/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody = {
  organizationId?: string | undefined;
  workspaceId?: string | undefined;
  tenantId?: string | undefined;
  accountId?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  scopes?: Array<string> | undefined;
  expiresAt?: Date | undefined;
  maxUses?: number | undefined;
  allowedIps?: Array<string> | undefined;
  rateLimit?: number | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  alertEmails?: Array<string> | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1ApiKeysStatus = {
  StatusUnspecified: "STATUS_UNSPECIFIED",
  StatusActive: "STATUS_ACTIVE",
  StatusSuspended: "STATUS_SUSPENDED",
  StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
  StatusRevoked: "STATUS_REVOKED",
  StatusExpired: "STATUS_EXPIRED",
  StatusRateLimited: "STATUS_RATE_LIMITED",
  StatusPendingReview: "STATUS_PENDING_REVIEW",
  StatusDeprecated: "STATUS_DEPRECATED",
  StatusMaintenance: "STATUS_MAINTENANCE",
} as const;
export type PostApiLeadScraperMicroserviceApiV1ApiKeysStatus = ClosedEnum<
  typeof PostApiLeadScraperMicroserviceApiV1ApiKeysStatus
>;

export type PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey = {
  id?: string | undefined;
  name?: string | undefined;
  keyHash?: string | undefined;
  keyPrefix?: string | undefined;
  scopes?: Array<string> | undefined;
  allowedIps?: Array<string> | undefined;
  allowedDomains?: Array<string> | undefined;
  allowedEnvironments?: Array<string> | undefined;
  isTestKey?: boolean | undefined;
  requestsPerSecond?: number | undefined;
  requestsPerDay?: number | undefined;
  concurrentRequests?: number | undefined;
  monthlyRequestQuota?: string | undefined;
  costPerRequest?: number | undefined;
  billingTier?: string | undefined;
  totalRequests?: string | undefined;
  totalErrors?: string | undefined;
  lastUsedAt?: Date | undefined;
  averageResponseTime?: number | undefined;
  endpointUsageJson?: string | undefined;
  errorRatesJson?: string | undefined;
  recentErrors?: string | undefined;
  successfulRequestsCount?: number | undefined;
  successRate?: number | undefined;
  status?: PostApiLeadScraperMicroserviceApiV1ApiKeysStatus | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  expiresAt?: Date | undefined;
  deletedAt?: Date | undefined;
  lastRotatedAt?: Date | undefined;
  lastSecurityReviewAt?: Date | undefined;
  requiresClientSecret?: boolean | undefined;
  clientSecretHash?: string | undefined;
  enforceHttps?: boolean | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  clientCertificateHash?: string | undefined;
  requireRequestSigning?: boolean | undefined;
  description?: string | undefined;
  metadataJson?: string | undefined;
  tags?: Array<string> | undefined;
  apiVersion?: string | undefined;
  supportedFeatures?: Array<string> | undefined;
  documentationUrl?: string | undefined;
  supportContact?: string | undefined;
  logAllRequests?: boolean | undefined;
  lastRotationReason?: string | undefined;
  lastRotationDate?: Date | undefined;
  rotationFrequencyDays?: number | undefined;
  complianceStandards?: Array<string> | undefined;
  requiresAuditLogging?: boolean | undefined;
  dataResidency?: string | undefined;
  approvedIntegrations?: Array<string> | undefined;
  alertEmails?: Array<string> | undefined;
  webhookUrl?: string | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
  alertOnErrorSpike?: boolean | undefined;
  errorAlertThreshold?: number | undefined;
  monitoringIntegrations?: Array<string> | undefined;
  encrypted?: boolean | undefined;
  dataClassification?: string | undefined;
  maxUses?: number | undefined;
  rateLimit?: number | undefined;
};

/**
 * Creates a new API key with specified permissions and settings
 */
export type PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody = {
  apiKey?: PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey | undefined;
  keyValue?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string().optional(),
    workspaceId: z.string().optional(),
    tenantId: z.string().optional(),
    accountId: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    rateLimit: z.number().int().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    alertEmails: z.array(z.string()).optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$Outbound = {
  organizationId?: string | undefined;
  workspaceId?: string | undefined;
  tenantId?: string | undefined;
  accountId?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  scopes?: Array<string> | undefined;
  expiresAt?: string | undefined;
  maxUses?: number | undefined;
  allowedIps?: Array<string> | undefined;
  rateLimit?: number | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  alertEmails?: Array<string> | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody
  > = z.object({
    organizationId: z.string().optional(),
    workspaceId: z.string().optional(),
    tenantId: z.string().optional(),
    accountId: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    rateLimit: z.number().int().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    alertEmails: z.array(z.string()).optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1ApiKeysRequestBodyToJSON(
  postApiLeadScraperMicroserviceApiV1ApiKeysRequestBody:
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1ApiKeysRequestBody,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1ApiKeysRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$inboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1ApiKeysStatus> = z
    .nativeEnum(PostApiLeadScraperMicroserviceApiV1ApiKeysStatus);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$outboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1ApiKeysStatus> =
    PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status: PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$inboundSchema
      .default("STATUS_UNSPECIFIED"),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastRotatedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastSecurityReviewAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  keyHash?: string | undefined;
  keyPrefix?: string | undefined;
  scopes?: Array<string> | undefined;
  allowedIps?: Array<string> | undefined;
  allowedDomains?: Array<string> | undefined;
  allowedEnvironments?: Array<string> | undefined;
  isTestKey?: boolean | undefined;
  requestsPerSecond?: number | undefined;
  requestsPerDay?: number | undefined;
  concurrentRequests?: number | undefined;
  monthlyRequestQuota?: string | undefined;
  costPerRequest?: number | undefined;
  billingTier?: string | undefined;
  totalRequests?: string | undefined;
  totalErrors?: string | undefined;
  lastUsedAt?: string | undefined;
  averageResponseTime?: number | undefined;
  endpointUsageJson?: string | undefined;
  errorRatesJson?: string | undefined;
  recentErrors?: string | undefined;
  successfulRequestsCount?: number | undefined;
  successRate?: number | undefined;
  status: string;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  expiresAt?: string | undefined;
  deletedAt?: string | undefined;
  lastRotatedAt?: string | undefined;
  lastSecurityReviewAt?: string | undefined;
  requiresClientSecret?: boolean | undefined;
  clientSecretHash?: string | undefined;
  enforceHttps?: boolean | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  clientCertificateHash?: string | undefined;
  requireRequestSigning?: boolean | undefined;
  description?: string | undefined;
  metadataJson?: string | undefined;
  tags?: Array<string> | undefined;
  apiVersion?: string | undefined;
  supportedFeatures?: Array<string> | undefined;
  documentationUrl?: string | undefined;
  supportContact?: string | undefined;
  logAllRequests?: boolean | undefined;
  lastRotationReason?: string | undefined;
  lastRotationDate?: string | undefined;
  rotationFrequencyDays?: number | undefined;
  complianceStandards?: Array<string> | undefined;
  requiresAuditLogging?: boolean | undefined;
  dataResidency?: string | undefined;
  approvedIntegrations?: Array<string> | undefined;
  alertEmails?: Array<string> | undefined;
  webhookUrl?: string | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
  alertOnErrorSpike?: boolean | undefined;
  errorAlertThreshold?: number | undefined;
  monitoringIntegrations?: Array<string> | undefined;
  encrypted?: boolean | undefined;
  dataClassification?: string | undefined;
  maxUses?: number | undefined;
  rateLimit?: number | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.date().transform(v => v.toISOString()).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status: PostApiLeadScraperMicroserviceApiV1ApiKeysStatus$outboundSchema
      .default("STATUS_UNSPECIFIED"),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    lastRotatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastSecurityReviewAt: z.date().transform(v => v.toISOString()).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.date().transform(v => v.toISOString()).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1ApiKeysApiKeyToJSON(
  postApiLeadScraperMicroserviceApiV1ApiKeysApiKey:
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1ApiKeysApiKey,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1ApiKeysApiKeyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    apiKey: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$inboundSchema
    ).optional(),
    keyValue: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$Outbound = {
  apiKey?:
    | PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$Outbound
    | undefined;
  keyValue?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody
  > = z.object({
    apiKey: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1ApiKeysApiKey$outboundSchema
    ).optional(),
    keyValue: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1ApiKeysResponseBodyToJSON(
  postApiLeadScraperMicroserviceApiV1ApiKeysResponseBody:
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1ApiKeysResponseBody,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1ApiKeysResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1ApiKeysResponseBody' from JSON`,
  );
}
